import React from 'react';
import { connect } from 'react-redux';
import { selectAreFontsReady } from '@ff-os/pdp-shared-redux/slices/fontsSlice';
import { selectLanguage } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { Clip } from '@ff-os/rendering-shared/Clip';
import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { PaintablesRenderer } from '@ff-os/shared-react/components/paintables-renderer/PaintablesRenderer';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { Paintable } from 'ff-canvas';

const _Preview2d = ({
    paintables, spaces, language,
    fontsReady, previewClip
}: Props) => {
    return (
        <PaintablesRenderer withTransitions
            paintables={paintables}
            spaces={spaces}
            language={language}
            fontsReady={fontsReady}
            previewClip={previewClip} />
    );
};

type Props = {
    paintables: Paintable[];
    spaces: Spaces;
    language: string;
    fontsReady: boolean;
    previewClip?: Clip;
};

const mapStateToProps = (state: GiftPdpState) => ({
    fontsReady: selectAreFontsReady(state),
    language: selectLanguage(state)
});

export const Preview2d = connect(
    mapStateToProps
)(_Preview2d);